/**
 * Builds the body of POST /feasibility from what the wizard knows: the Basics values (typed or saved), the saved
 * region and profiling selection, and, for the Quotas table, the quota rows in the same shape as QuotaSetting/create.
 * Returns null when there is nothing to calculate yet (no country chosen).
 */
const GENDER = { both: 'both', male: 'male', female: 'female' };

const whole = (v) => (/^\d+$/.test(String(v === undefined || v === null ? '' : v).trim()) ? Number(v) : undefined);
const decimal = (v) => (String(v === undefined || v === null ? '' : v).trim() !== '' && Number.isFinite(Number(v)) ? Number(v) : undefined);
const idsOf = (list) => (list || []).map((x) => (x && typeof x === 'object' ? x.id : x)).filter(Boolean);

/**
 * @param {{ basics?: any, region?: any, profilingAnswers?: any[], quota?: any }} source
 *   basics: the Basics form values or the saved basic settings (same field names)
 *   region: the saved RegionSettings ({ states, wholeStates, cities } as records or ids)
 *   profilingAnswers: the saved profiling answers ([{ id, ... }])
 *   quota: { mode, data } to also get one figure per quota row; leave it out for the planning strip only
 */
export function buildFeasibilityInput({ basics, region, profilingAnswers, quota } = {}) {
  if (!basics || String(basics.country_id === undefined || basics.country_id === null ? '' : basics.country_id).trim() === '') return null;
  const input = {
    countryId: whole(basics.country_id),
    minAge: whole(basics.ageMinLimit),
    maxAge: whole(basics.ageMaxLimit),
    gender: GENDER[String(basics.gender || 'both').toLowerCase()] || 'both',
    stateIds: idsOf(region && region.states),
    wholeStateIds: idsOf(region && region.wholeStates),
    cityIds: idsOf(region && region.cities),
    profilingAnswerIds: idsOf(profilingAnswers),
    wantedCompletes: whole(basics.noOfWantedCompletes),
    incidenceRate: decimal(basics.estimatedIncidenceRate),
    lengthOfInterview: decimal(basics.estimatedLenghthOfInterview),
  };
  if (input.countryId === undefined) return null;
  Object.keys(input).forEach((k) => { if (input[k] === undefined) delete input[k]; });
  if (quota && Array.isArray(quota.data) && quota.data.length > 0) input.quota = { mode: quota.mode, data: quota.data };
  return input;
}
